import { forwardRef } from "react";

import { useField } from "formik";
import { PasswordProps as AntdPasswordProps } from "antd/lib/input";
import { Input as AntdInput, InputRef as AntdInputRef } from "antd";

const InputPassword = forwardRef<AntdInputRef, AntdPasswordProps & { name: string }>(
  (
    {
      name,
      // eslint-disable-next-line no-unused-vars
      value: $value,
      onChange: $onChange,
      onBlur: $onBlur,
      ...restProps
    },
    ref,
  ) => {
    const [ { value, onChange, onBlur } ] = useField(name);

    return (
      <AntdInput.Password
        ref={ ref }
        name={ name }
        id={ name }
        value={ value }
        onChange={ (event) => {
          onChange(event);
          $onChange?.(event);
        } }
        onBlur={ (event) => {
          onBlur(event);
          $onBlur?.(event);
        } }
        { ...restProps }
      />
    );
  },
);

InputPassword.displayName = "InputPassword";

export default InputPassword;
